<template>
  <div class="container">
    <md-card class="dash-content">
      <PageHeader title="Orders Management" />
      <div class="loader">
        <Wave v-if="loading || updating" width="50px" color="#d9534f" />
      </div>
      <md-table
        v-model="payout_orders.mdData"
        md-card
        md-sort="title"
        md-sort-order="asc"
      >
        <md-table-toolbar class="mb-4">
          <div class="md-toolbar-section-start">
            <md-button
              :disabled="exporting"
              class="md-primary button-icon"
              @click="exportExcel"
            >
              Download Excel
              <img src="@/assets/svg/excel.svg" />
            </md-button>
          </div>
          <div class="toolbar-filter-wrapper">
            <md-field md-clearable class="md-toolbar-section-end">
              <md-input placeholder="Search by name..." v-model="search" />
            </md-field>
            <md-menu md-size="medium" md-align-trigger>
              <md-button
                md-menu-trigger
                class="md-primary button-icon"
                disabled
              >
                Filter
                <img src="@/assets/svg/filter.svg" />
              </md-button>

              <md-menu-content>
                <md-menu-item>Approved</md-menu-item>
                <md-menu-item>Pending</md-menu-item>
              </md-menu-content>
            </md-menu>
          </div>
        </md-table-toolbar>

        <md-table-row slot="md-table-row" slot-scope="{ item }">
          <md-table-cell md-label="S/N" md-numeric class="text-center">{{
            item.id
          }}</md-table-cell>
          <md-table-cell md-label="Vendor Name">{{
            item.vendor.first_name + " " + item.vendor.last_name
          }}</md-table-cell>
          <md-table-cell md-label="Product Name">{{
            item.product_name
          }}</md-table-cell>
          <md-table-cell md-label="Product Total Price">{{
            item.total | formatMoney
          }}</md-table-cell>

          <md-table-cell md-label="Created At">{{
            item.created_at | formatDate
          }}</md-table-cell>
          <md-table-cell md-label="Action">
            <md-button
              v-if="hasPermission"
              class="md-success button-icon"
              md-menu-trigger
              :disabled="updating"
              @click="approve(item.id)"
            >
              Approve Payment
            </md-button>
          </md-table-cell>
        </md-table-row>
      </md-table>
      <span v-if="loading" class="b-loading">Loading...</span>
      <pagination
        v-model="payout_orders.mdPage"
        :records="payout_orders.mdCount"
        :per-page="payout_orders.mdPerPage"
        @paginate="updatePagination"
      />
    </md-card>

    <md-dialog :md-active.sync="show">
      <md-dialog-title>Order Details</md-dialog-title>
      <div class="cancel-modal">
        <i class="material-icons" @click="show = false">close</i>
      </div>

      <div class="modal-contain" v-if="payout">
        <div>
          <h4>Vendors information</h4>
        </div>

        <div v-if="payout.items.length">
          <div v-for="item in payout.items" :key="item.id">
            <div
              class="d-flex"
              style="justify-content: space-between; margin: 10px 0px"
            >
              <div
                class="d-flex"
                style="justify-content: space-between"
                v-if="item.product"
              >
                <div>
                  <div>
                    {{
                      item.product.created_by.first_name +
                      " " +
                      item.product.created_by.last_name
                    }}
                  </div>
                  <small style="font-size: 10px">{{
                    item.product.created_by.email
                  }}</small>
                </div>
                <div>({{ (item.quantity * item.price) | formatMoney }})</div>
              </div>
            </div>
          </div>
        </div>

        <hr />
        <div>
          <h4>Items</h4>
        </div>

        <div v-if="payout.items.length">
          <div v-for="item in payout.items" :key="item.id">
            <div class="d-flex" style="justify-content: space-between">
              <div>{{ item.title }}</div>
              <div>{{ item.quantity }} X {{ item.price }}</div>
            </div>
          </div>
        </div>
        <div v-else>Empty Items</div>
        <hr />

        <div class="item">
          <strong>Payment Status</strong>
          <div
            class="badge"
            :class="{ success: payout.payment_status == 'paid' }"
          >
            {{ payout.payment_status }}
          </div>
        </div>
        <div class="item">
          <strong>payout Code</strong>
          <span> {{ payout.order_code }}</span>
        </div>
        <div class="item">
          <strong>Order Status</strong>
          <span> {{ payout.order_status.title }}</span>
        </div>
        <div class="item">
          <strong>Date Created</strong>
          <span> {{ payout.created_at | formatDate }}</span>
        </div>
      </div>
    </md-dialog>
  </div>
</template>

<script>
import { PageHeader, Wave } from "@/components";
import { createNamespacedHelpers } from "vuex";
const { mapActions, mapGetters } = createNamespacedHelpers("product");

export default {
  name: "Payout Orders",
  components: {
    PageHeader,
    Wave
  },
  data: () => ({
    search: null,
    show: false,
    fetching: false,
    updating: false,
    exporting: false,
    time: null,
    payout: null,
    showStatus: false,
    metadata: true,
    form: {
      shipping_status: ""
    }
  }),
  watch: {
    search(val) {
      this.waitForIt(val);
    }
  },
  methods: {
    ...mapActions([
      "getPayoutOrders",
      "updatePayoutOrderStatus",
      "approvePayment"
    ]),
    async exportExcel() {
      this.exporting = true;
      await this.$store.dispatch("auth/export", { model: "order" });
      this.exporting = false;
    },
    async updatePagination(page) {
      let data = { page };
      if (this.search) data.keyword = this.search;
      await this.getOrders(data);
    },
    async submitSearch() {
      await this.getOrders({ keyword: this.search });
    },
    async updateStatus(id, status, field) {
      let data = { id };
      if (field == "payment_status") {
        data.payment_status = status;
      }
      if (field == "order_status") {
        data.order_status_id = this.form.order_status;
      }

      try {
        this.updating = true;
        await this.updateOrderStatus(data);
        this.updating = false;
        this.toast("success", "Order Status Updated ");
        if (field == "order_status") {
          this.showStatus = false;
          this.getOrders();
        }
      } catch (err) {
        this.updating = false;
        this.toast("error", "Opps, Something went wrong");
      }
    },

    setPayoutOrder(payout) {
      this.show = true;
      this.payout = payout;
    },
    waitForIt(val) {
      if (this.time) {
        clearTimeout(this.time);
      }
      this.time = setTimeout(() => this.submitSearch(val), 1000);
    },
    async approve(id) {
      const conf = confirm("Are your sure?");
      if (conf) {
        try {
          await this.approvePayment(id);
          this.getPayoutOrders({});
          this.toast("success", "Payment approved");
        } catch (err) {
          this.toast("error", "Opps, Something went wrong ");
        }
      }
    }
  },
  created() {
    this.searched = this.users;
  },
  mounted() {
    this.getPayoutOrders({});
  },
  computed: {
    ...mapGetters(["loading", "payout_orders"]),
    hasPermission() {
      return this.$store.getters["auth/has_module_permission"]("crud");
    }
  }
};
</script>

<style lang="scss" scoped>
// .md-field {
//   max-width: 500px;
// }
.md-table-cell {
  width: 0% !important;
  padding: 0rem 0.8rem;
}

.md-table + .md-table {
  margin-top: 16px;

  thead {
    height: 50px !important;
  }
}

.badge {
  background: #f3f3f3;

  &.success {
    background: #5cb85c;
  }

  &.danger {
    background: #d9534f;
  }
}

.modal-contain {
  max-width: 100%;
  width: 600px;
  padding: 20px;
  overflow-y: auto;

  .item {
    display: flex;
    gap: 20px;
    padding: 10px 10px;
    margin: 5px 0px;

    &:nth-child(odd) {
      background: #00ff1f0d;
    }
  }

  .media {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    .display {
      height: 150px;
      width: 150px;
      background: #ccc;
      border-radius: 5px;
      img {
        border-radius: 5px;
        width: 100%;
        object-fit: cover;
      }
    }
  }
}
.loader {
  position: absolute;
  top: 24px;
  right: 30px;
}
</style>
